export class GetContent {
  constructor() {
    this._getContent = document.querySelectorAll('[data-get-content]');
    this._parent = null;
    this._type = null;
    this._parentSection = null;
    this._group = null;
    this._list = null;
    this._button = null;
    this._buttonParent = null;

    this._documentClickHandler = this._documentClickHandler.bind(this);
  }

  init() {
    if (!this._getContent.length) {
      return;
    }

    document.addEventListener('click', this._documentClickHandler);
  }

  _documentClickHandler(evt) {
    const target = evt.target;

    if (!target.closest('[data-get-content-button]') && !target.closest('[data-get-content-button].is-active')) {
      return;
    }

    this._parent = target.closest('[data-get-content]');

    this._type = this._parent.dataset.getContent;
    if (this._parent.dataset.parentSection) {
      this._parentSection = this._parent.dataset.parentSection;
    }
    if (this._parent.dataset.group) {
      this._group = this._parent.dataset.group;
    }
    this._list = this._parent.querySelector('[data-get-content-list]');
    this._button = this._parent.querySelector('[data-show-more-button]');

    const currentButton = this._parent.querySelector('[data-get-content-button].is-active');
    const button = target.closest('[data-get-content-button]');

    currentButton.classList.remove('is-active');
    button.classList.add('is-active');

    const params = {
      xmlId: button.dataset.getContentButton,
      type: this._type,
      parentSection: this._parentSection,
      group: this._group,
    };

    console.log(params);

    fetch('/local/templates/ballet/ajax/get-content.php', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      body: new URLSearchParams(params).toString(),
    })
        .then((response) => response.text())
        .then((response) => {
          console.log(response);
          const parser = new DOMParser();
          const doc = parser.parseFromString(response, 'text/html');
          const elements = doc.querySelectorAll('[data-get-content-item]');
          const showMoreButton = doc.querySelector('[data-show-more-button]');

          this._list.innerHTML = '';

          if (elements.length) {
            elements.forEach((element) => {
              this._list.appendChild(element);
            });
          }

          if (this._button) {
            if (elements.length >= 1 && showMoreButton) {
              this._button.style.display = 'flex';
              if (this._type === 'archive' || this._type === 'broadcasts' || this._type === 'video' || this._type === 'participants') {
                this._button.setAttribute('data-url', showMoreButton.dataset.url);
                this._button.setAttribute('data-max-pages', showMoreButton.dataset.maxPages);
              }
            } else if (!showMoreButton) {
              this._button.style.display = 'none';
            }
          }
        });
  }
}
